import { CircularProgress, Grid } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import DeleteBin from 'utils/images/bin.svg';
import { capitalizeFirstLetter } from '../../../utils';
import BackButton from '../BackButton';
import Button from '../Button';
import ControlButton from '../ControlButton';
import { EditorControlButtons } from '../EditorControls';

const SpacedControls = styled.div`
  margin-right: 10px;
  float: left;
`;
const DeleteGroups = styled.div`
  position: absolute;
  right: 0;
`;
const StyledCircularProgress = withStyles({
  root: {
    height: '20px',
    width: '20px',
  },
})(CircularProgress);

const DeleteConfirmDialog = withStyles({
  paper: {
    maxWidth: '350px',
    borderRadius: '11px',
  },
})(Dialog);

const DeleteConfirmDialogContent = withStyles({
  root: {
    padding: '10px !important',
    textAlign: 'center',
  },
})(DialogContent);

const DeleteConfirmDialogActions = withStyles({
  root: {
    paddingBottom: '20px',
    justifyContent: 'center',
  },
})(DialogActions);

const DeletePrompt = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  padding-right: 30px;
  cursor: pointer;
`;

const DeleteIcon = styled.img`
  width: 14px;
`;

const DeletePromptText = styled.p`
  font-size: 13px;
  letter-spacing: -0.2px;
  display: inline-block;
  padding-left: 7px;
`;

const DeleteConfirmHeader = styled.h2`
  font-weight: 500;
  letter-spacing: -0.4px;
`;

const DeleteConfirmText = styled.p`
  font-size: 13px;
`;

const DescendantTypes = {
  menu: 'categories and products',
  category: 'products',
  group: 'groups',
};

function EditorButtons(props) {
  const { create, loading, type, onSubmit, onUpdate, onCancel, onDelete } =
    props;
  const fmtType = capitalizeFirstLetter(type);

  const [openDeleteConfirm, setDeleteConfirmOpen] = React.useState(false);

  const handleDeleteConfirmOpen = () => setDeleteConfirmOpen(true);
  const handleDeleteConfirmClose = () => setDeleteConfirmOpen(false);
  const handleDeleteConfirmed = e => {
    onDelete(e);
    handleDeleteConfirmClose();
  };

  const handleOnCancel = e => (loading ? null : onCancel(e));

  return (
    <EditorControlButtons>
      <Grid container>
        <Grid item xs={12}>
          <SpacedControls>
            {loading ? (
              <StyledCircularProgress />
            ) : create ? (
              <ControlButton width="107px" dark onClick={onSubmit} edit={true}>
                Save
              </ControlButton>
            ) : (
              <ControlButton width="107px" dark onClick={onUpdate}>
                Save
              </ControlButton>
            )}
          </SpacedControls>
          <SpacedControls>
            <BackButton width="107px" onClick={handleOnCancel} value="Cancel" />
          </SpacedControls>
        </Grid>

        <DeleteGroups>
          {onDelete && (
            <React.Fragment>
              {create || loading ? null : (
                <DeletePrompt onClick={handleDeleteConfirmOpen}>
                  <DeleteIcon src={DeleteBin} alt="Delete" />
                  <DeletePromptText>Delete {fmtType}</DeletePromptText>
                </DeletePrompt>
              )}

              <DeleteConfirmDialog
                open={openDeleteConfirm}
                onClose={handleDeleteConfirmClose}
              >
                <DeleteConfirmDialogContent>
                  <DeleteConfirmHeader>
                    Confirm you want to delete this {type}
                  </DeleteConfirmHeader>
                  {DescendantTypes[type] === undefined ? null : (
                    <DeleteConfirmText>
                      <strong>Please note:</strong> Any {DescendantTypes[type]}{' '}
                      inside this {type} will also be deleted.
                    </DeleteConfirmText>
                  )}
                </DeleteConfirmDialogContent>
                <DeleteConfirmDialogActions>
                  <Button width="135px" light onClick={handleDeleteConfirmed}>
                    Yes, delete
                  </Button>
                  <Button width="135px" dark onClick={handleDeleteConfirmClose}>
                    No, cancel
                  </Button>
                </DeleteConfirmDialogActions>
              </DeleteConfirmDialog>
            </React.Fragment>
          )}
        </DeleteGroups>
      </Grid>
    </EditorControlButtons>
  );
}

EditorButtons.propTypes = {
  loading: PropTypes.bool,
  create: PropTypes.bool,
  type: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default EditorButtons;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/components/shared/EditorButtons/index.jsx